import { Box, Card, Col, Link, Row, Typography, ViewContainer } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import { ROUTE_REDESIGN_APP_ADMIN } from 'constants/routes';

import featureFlags from 'constants/featureFlags';
import React from 'react';
import AddOrUpdateAgent from './AddOrUpdateAgent';
import SearchAgent from './SearchAgent';

const FindAnAgent = () => {
  const TriggerButton = (props) => (
    <Link {...props} startIcon={'addOutlined'}>
      Add Agent
    </Link>
  );
  return (
    <Feature allowed={featureFlags.ACCESS_FIND_AGENT}>
      <ViewContainer
        title={'Find An Agent Administration'}
        returnRoute={{ text: 'Application Administration', route: ROUTE_REDESIGN_APP_ADMIN }}
        hideStartQuote
        hidePolicyViewChange>
        <Row mb={2}>
          <Card>
            <Row spacing={4}>
              <Col xs={4}>
                <Typography color="textSecondary">
                  Welcome to the MSA Web Find an Agent Administration Home Page. The links to the right offer access to all of the resouces you need to review
                  or edit agent location information.
                </Typography>
              </Col>
              <Col xs={8}>
                <Feature allowed={featureFlags.ACCESS_FIND_AGENT}>
                  <Row>
                    <AddOrUpdateAgent triggerButton={TriggerButton} />
                  </Row>
                  <Row>
                    <Typography color="textSecondary">From this screen you may add new agents.</Typography>
                  </Row>
                  <Box p={2} />
                  <Row>
                    <SearchAgent />
                  </Row>
                  <Row>
                    <Typography color="textSecondary">From this screen you may update contact and location information for agents.</Typography>
                  </Row>
                </Feature>
              </Col>
            </Row>
          </Card>
        </Row>
      </ViewContainer>
    </Feature>
  );
};
export default FindAnAgent;
